var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import format from 'string-format';
import Box from '@mui/material/Box';
import { OGButton } from '@opengear/buttons';
import { useFormContainerContext } from '@/components/layout/forms';
import { FIRMWARE_UPGRADE_TASKS_ROUTE } from '@/constants/routes';
import { NewFirmwareUpgradeStep, useNewFirmwareUpgradeSteps } from './new-firmware-upgrade-steps-context';
function NewFirmwareUpgradeBackButton() {
    var _a;
    var _this = this;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _b = useNewFirmwareUpgradeSteps(), activeStep = _b.activeStep, handleStepBack = _b.handleStepBack;
    var trigger = useFormContainerContext().trigger;
    var buttonsText = (_a = {},
        _a[NewFirmwareUpgradeStep.Setup] = t('pages.firmware_upgrade_new.steps.setup.buttons.back'),
        _a[NewFirmwareUpgradeStep.Schedule] = t('pages.firmware_upgrade_new.steps.schedule.buttons.back'),
        _a[NewFirmwareUpgradeStep.Review] = t('pages.firmware_upgrade_new.steps.review_confirm.buttons.back'),
        _a[NewFirmwareUpgradeStep.Confirm] = t('pages.firmware_upgrade_new.steps.review_confirm.buttons.back'),
        _a);
    var handleBack = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(activeStep === NewFirmwareUpgradeStep.Setup)) return [3 /*break*/, 1];
                    navigate(FIRMWARE_UPGRADE_TASKS_ROUTE);
                    return [3 /*break*/, 3];
                case 1:
                    handleStepBack();
                    return [4 /*yield*/, trigger()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [activeStep, handleStepBack, navigate, trigger]);
    return (_jsx(OGButton, __assign({ variant: "secondary", onClick: handleBack, sx: { marginRight: 2, minHeight: '36px' } }, { children: format(t('pages.firmware_upgrade_new.buttons.back'), buttonsText[activeStep]) })));
}
function NewFirmwareUpgradeNextButton() {
    var _a;
    var _this = this;
    var t = useTranslation().t;
    var _b = useNewFirmwareUpgradeSteps(), activeStep = _b.activeStep, handleStepNext = _b.handleStepNext;
    var _c = useFormContainerContext(), formState = _c.formState, trigger = _c.trigger;
    var buttonsText = (_a = {},
        _a[NewFirmwareUpgradeStep.Setup] = t('pages.firmware_upgrade_new.steps.setup.buttons.next'),
        _a[NewFirmwareUpgradeStep.Schedule] = t('pages.firmware_upgrade_new.steps.schedule.buttons.next'),
        _a[NewFirmwareUpgradeStep.Review] = t('pages.firmware_upgrade_new.steps.review_confirm.buttons.next'),
        _a[NewFirmwareUpgradeStep.Confirm] = t('pages.firmware_upgrade_new.steps.review_confirm.buttons.next'),
        _a);
    var handleNext = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handleStepNext();
                    return [4 /*yield*/, trigger()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [handleStepNext, trigger]);
    return (_jsx(OGButton, __assign({ disabled: !formState.isValid, onClick: handleNext, variant: "primary" }, { children: format(t('pages.firmware_upgrade_new.buttons.next'), buttonsText[activeStep]) })));
}
export function NewFirmwareUpgradeButtons() {
    return (_jsxs(Box, __assign({ width: "100%", display: "flex", justifyContent: "space-between" }, { children: [_jsx(NewFirmwareUpgradeBackButton, {}), _jsx(NewFirmwareUpgradeNextButton, {})] })));
}
